import * as React from 'react';
import { jsx, css } from '@emotion/react';
import { setTime, wait } from 'Src/me/pages/guest/proposals/new/utils';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { NonInteractiveContinueHandlerType, FeaturePropsType } from '../../../../../chat/views/types';
import { scrollToBottomOfChat } from '../../../../../chat/functional/scrollToBottomOfChat';
import { RenderSingleImagePropsType } from '../../../../../chat/views/SingleImage/index';

const { tablet, mobile } = mediaQueries();

export type SingleImagePropsType = FeaturePropsType<RenderSingleImagePropsType, NonInteractiveContinueHandlerType>

export const SingleImage = (props: SingleImagePropsType) => {
  const {
    doesNotScroll,
    isInstant = false,
    continueHandler,
    imagePaths,
    altText,
    viewWidth,
    viewHeight,
    imageRatio,
    waitTime = 0.4,
    delayTime = 2,
    withWebp,
  } = props;
  const [isShow, setIsShow] = React.useState(isInstant);
  const { imagePath, webp } = imagePaths;

  React.useEffect(() => {
    (async () => {
      if (!isInstant) {
        await wait(waitTime);

        setIsShow(true);

        await wait(delayTime + 0.4);
      }

      // 次に進む
      continueHandler({
        selfDomReferences: [],
      });
    })();
  }, [isInstant, waitTime, delayTime, continueHandler]);

  React.useEffect(() => {
    if (!doesNotScroll) scrollToBottomOfChat();
  }, [doesNotScroll]);

  return (
    <div
      css={css`
        padding: 30px 1em 0;
        position: relative;
        opacity: 0;
        bottom: -10px;
        transition: opacity ${setTime(0.4)}s ${setTime(0.4)}s, bottom ${setTime(0.4)}s ${setTime(0.4)}s;

        ${isShow && css`
          opacity: 1;
          bottom: 0;
        `}
      `}
    >
      <div
        css={css`
          width: 100%;
          max-width: ${viewWidth?.pc ? `${viewWidth.pc}px` : 'none'};
          height: auto;
          max-height: ${viewHeight?.pc ? `${viewHeight.pc}px` : 'none'};
          margin-inline: auto;

          ${(viewWidth?.pc && viewWidth?.mobile)
            ? autoResponsiveClamp('max-width', viewWidth.pc, viewWidth.mobile)
            : mobile(() => css`
                max-width: ${viewWidth?.mobile ? `${viewWidth.mobile}px` : 'none'};
              `)
          }

          ${(viewHeight?.pc && viewHeight?.mobile)
            ? autoResponsiveClamp('max-height', viewHeight.pc, viewHeight.mobile)
            : mobile(() => css`
                max-height: ${viewHeight?.mobile ? `${viewHeight.mobile}px` : 'none'};
              `)
          }
        `}
      >
        <div
          css={css`
            font-size: 0;
            width: 100%;
            height: 100%;

            img {
              max-width: 100%;
              max-height: 100%;
              aspect-ratio: ${imageRatio.width} / ${imageRatio.height};
            }
          `}
        >
          {withWebp
            ? (
              <picture>
                <source
                  srcSet={webp}
                  type="image/webp"
                />
                <img
                  src={imagePath}
                  alt={altText}
                />
              </picture>
            )
            : (
              <img
                src={imagePath}
                alt={altText}
              />
            )
          }
        </div>
      </div>
    </div>
  );
};
